import {gsap} from "gsap";
import {isMobile, isTablet} from "../components/helpers";
import {initParallaxSection} from "../components/parallax-section";

export function initBlogyouLanding() {
    if (!$('#blogyou_landing').length) return;
    initParallaxSection();
    initBlogyouGadgetsEffects();
}

function initBlogyouGadgetsEffects() {
    const tl = gsap.timeline({
        scrollTrigger: {
            scroller: isMobile() || isTablet() ? '' : '.scroller',
            trigger: ".blogyou-apple-gadgets",
            start: isMobile() || isTablet() ? 'top-=150% top' : 'top-=100% top',
            end: "bottom top",
            scrub: true
        }
    });
    gsap.utils.toArray(".apple-gadget").forEach(layer => {
        const depth = layer.dataset.depth;
        let movement = -($('.blogyou-apple-gadgets').height() * depth)
        if ($(window).height() / $(window).width() > 2) movement *= 0.9
        tl.to(layer, {y: movement, ease: "none"}, 0)
    });
}
